<script setup>
import WizardButton from "../../../components/ui-components/WizardButton.vue";
import {watch} from "vue";
const valid = defineModel('valid');
const model = defineModel()
watch(() => model.value.reservationType, (now) => {
    //console.log(now)
    valid.value = (now !== '');
}, {immediate: true, deep: true})

</script>

<template>
    <div class="flex flex-col gap-5 pb-6 pt-4">
        <div class="flex flex-col gap-4 items-start">
            <wizard-button
                @select="model.reservationType = 'single-day'"
                :active="model.reservationType === 'single-day'"
                icon="pi pi-clock"
                :title="$t('forms.blocking_same_day')"
                :description="$t('forms.blocking_same_day_desc')"
            ></wizard-button>

            <wizard-button
                @select="model.reservationType = 'multi-day'"
                :active="model.reservationType === 'multi-day'"
                icon="pi pi-calendar"
                :title="$t('forms.blocking_multi_day')"
                :description="$t('forms.blocking_multi_day_desc')"
            ></wizard-button>
        </div>
    </div>
</template>

<style scoped lang="scss">

</style>
